export default "__VITE_ASSET__oHaCxpTv__"